import React from "react";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="London" />
        <footer>
          This project was coded by Elzbieta Cekanauske and is{" "}
          <a
            href="https://github.com/Padaras/React_Weather"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and hosted on{" "}
          <a href="https://forecastreact.netlify.app/">Netlify</a>
        </footer>
      </div>
    </div>
  );
}